import React, { useState, useEffect } from "react";
import CustomerLayout from '../CustomerLayout';
import { Settings, Scale, FileText, CreditCard, KeyRound, Info, Loader2, Sliders } from 'lucide-react';
import { motion } from 'framer-motion';

import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { getCustomerCompanyDetails } from "../../../../services/staffingService";

import Legal from "./legal";
import SSO from "./sso";
import APIVersion from "./apiversion";
import DocumentsTab from "./documents";
import Payments from "./payments";
import CustomerPreferencesTab from "./customerPreferences";

const TABS = [
  { key: "preferences", label: "Preferences",         Icon: Sliders      },
  { key: "legal",       label: "Legal & Compliance",  Icon: Scale        },
  { key: "documents",   label: "Documents",           Icon: FileText     },
  { key: "payments",    label: "Payments",            Icon: CreditCard   },
  // { key: "sso",         label: "SSO",                  Icon: KeyRound    },
  { key: "api-version", label: "API Version",         Icon: Info         },
];

const Account = () => {
  const { customerCompanyId } = useParams();
  const [customerCompany, setCustomerCompany] = useState(null);
  const [activeTab, setActiveTab] = useState("legal");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!customerCompanyId) return;
    getCustomerCompanyDetails(customerCompanyId)
      .then(res => setCustomerCompany(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [customerCompanyId]);

  return (
    <CustomerLayout>
      <main className="flex-1 overflow-y-auto">
        <div className="p-6">
          {/* Page header */}
          <div className="mb-6 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#404880]/10">
              <Settings size={20} className="text-[#404880]" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-gray-900">Admin Console</h1>
              <p className="text-sm text-gray-500">Configure settings for your enterprise.</p>
            </div>
          </div>

          {/* Tab bar */}
          <div className="mb-5 flex gap-1 border-b border-gray-200">
            {TABS.map(({ key, label, Icon }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`relative flex items-center gap-1.5 px-4 py-2.5 text-xs font-medium transition-colors ${
                  activeTab === key ? 'text-[#CC457D]' : 'text-gray-500 hover:text-gray-800'
                }`}
              >
                <Icon size={13} /> {label}
                {activeTab === key && (
                  <motion.div
                    layoutId="account-tab-indicator"
                    className="absolute bottom-0 left-0 right-0 h-0.5 rounded-t bg-[#CC457D]"
                  />
                )}
              </button>
            ))}
          </div>

          {/* Tab content */}
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <Loader2 size={28} className="animate-spin text-[#404880]" />
            </div>
          ) : customerCompany && (
            <>
              {activeTab === "preferences" && (
                <CustomerPreferencesTab customerCompany={customerCompany} setCustomerCompany={setCustomerCompany} />
              )}
              {activeTab === "legal" && (
                <Legal customerCompany={customerCompany} setCustomerCompany={setCustomerCompany} />
              )}
              {activeTab === "documents" && (
                <DocumentsTab
                  customerCompany={customerCompany}
                  setCustomerCompany={setCustomerCompany}
                  customerCompanyId={customerCompany._id}
                />
              )}
              {activeTab === "payments" && <Payments />}
              {/* {activeTab === "sso" && <SSO customerCompanyId={customerCompanyId} />} */}
              {activeTab === "api-version" && <APIVersion />}
            </>
          )}
        </div>
      </main>
    </CustomerLayout>
  );
};

export default Account;

